module.exports = "<div class=\"knowledge-panel\">\n    <div class=\"panel\" ng-repeat=\"panel in $ctrl.cata\">\n        <div class=\"title\">{{panel.title}}</div>\n        <div class=\"item\" ng-repeat=\"item in panel.list\">\n            <div class=\"question\" ng-click=\"$ctrl.showDetail($event)\">{{item.question}}</div>\n            <div class=\"answer\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(item.answer)\"></div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/help/knowledge/knowledge.html
// module id = 1175
// module chunks = 3